<p-confirmDialog key="export" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="OptionSize">
	<div class="SubMenu">
		<h4>Students:</h4>

		<div class="GridMenu">
			<label>School:</label>
			<caass-schoolselector
				[Disabled]="IsLoading() == true"
				[ShowAll]="SchoolSelectShowAll"
				[ShowAllID]="SchoolSelectShowAllID"
				[ShowAllText]="SchoolSelectShowAllText"
			>
			</caass-schoolselector>

			<label>Active:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="StudentActiveOption" [(ngModel)]="StudentActiveOption">
				<option *ngFor="let o of lstActiveOptions" [ngValue]="o">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>

	<div class="SubMenu TopMargin">
		<h4>Guardians:</h4>

		<div class="GridMenu">
			<label>Guardians:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="GuardianOption" [(ngModel)]="GuardianOption">
				<option *ngFor="let o of lstGuardianOptions" [ngValue]="o">
					{{ o.Desc }}
				</option>
			</select>

			<label>Active:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="GuardianActiveOption" [(ngModel)]="GuardianActiveOption">
				<option *ngFor="let o of lstActiveOptions" [ngValue]="o">
					{{ o.Desc }}
				</option>
			</select>

			<label>Email:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="EmailOption" [(ngModel)]="EmailOption">
				<option *ngFor="let o of lstEmailOptions" [ngValue]="o">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>

	<div class="SubMenu TopMargin">
		<h4>Language:</h4>

		<div class="GridMenu">
			<label>Show Language:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="LanguageOptionID" [(ngModel)]="LanguageOptionID">
				<option *ngFor="let o of lstYN" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>

	<div class="SubMenu TopMargin">
		<h4>Format:</h4>

		<div class="GridMenu">
			<label>Format:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="FormatOption" [(ngModel)]="FormatOption">
				<option *ngFor="let o of lstFormatOptions" [ngValue]="o">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onExport()">Export</button>
	<button [disabled]="IsProcessing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
